import { ForeAftEnum } from "open-vessel-definition";
import { IBayPattern } from "./types/IPositionPatterns";
import { pad3 } from "@tedivo/tedivo-pure-helpers";

export function getPairedIsoBay(
  isoBay: IBayPattern,
  pairedBay: ForeAftEnum | undefined,
): IBayPattern | undefined {
  const pairedBayNumber =
    pairedBay !== undefined ? Number(isoBay) + (pairedBay === ForeAftEnum.FWD ? -2 : 2) : undefined;

  return pairedBayNumber !== undefined ? (pad3(pairedBayNumber) as IBayPattern) : undefined;
}
